console.log("VORYNEX Homepage V2 — script loaded");

(function () {
  // Theme toggle (persists choice, defaults to dark)
  // Guarded: this section doesn't embed its own header (the theme's
  // existing global header is used instead), so #themeToggle may not
  // exist on the page — never let a missing header element crash the
  // whole script.
  const themeToggle = document.getElementById('themeToggle');
  const savedTheme = localStorage.getItem('vpx-preview-theme') || 'dark';
  if (savedTheme === 'light') document.documentElement.setAttribute('data-theme', 'light');
  if (themeToggle) {
    themeToggle.addEventListener('click', () => {
      const isLight = document.documentElement.getAttribute('data-theme') === 'light';
      if (isLight) {
        document.documentElement.removeAttribute('data-theme');
        localStorage.setItem('vpx-preview-theme', 'dark');
      } else {
        document.documentElement.setAttribute('data-theme', 'light');
        localStorage.setItem('vpx-preview-theme', 'light');
      }
    });
  }

  // Mobile nav drawer — same guard, since #hamburgerBtn/#mobileNav
  // also live in the (not embedded) custom header.
  const hamburgerBtn = document.getElementById('hamburgerBtn');
  const mobileNav = document.getElementById('mobileNav');
  const mobileNavOverlay = document.getElementById('mobileNavOverlay');
  if (hamburgerBtn && mobileNav && mobileNavOverlay) {
    function toggleMobileNav() {
      hamburgerBtn.classList.toggle('open');
      mobileNav.classList.toggle('open');
      mobileNavOverlay.classList.toggle('open');
    }
    hamburgerBtn.addEventListener('click', toggleMobileNav);
    mobileNavOverlay.addEventListener('click', toggleMobileNav);
  }

  // Header scroll state — guarded the same way.
  const header = document.getElementById('mainHeader');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    });
  }

  // Scroll reveal — content is visible by default (see CSS); JS only
  // ADDS the hidden "pre-reveal" state right before observing, so a
  // JS failure or a non-firing observer (e.g. inside some editor
  // iframes) never leaves content permanently invisible.
  const revealEls = document.querySelectorAll('.reveal');
  if (window.IntersectionObserver) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          setTimeout(() => entry.target.classList.add('visible'), i * 60);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    revealEls.forEach(el => {
      el.classList.add('pre-reveal');
      io.observe(el);
      // Safety net: if the observer never fires for this element
      // (e.g. it's already in view but the browser is slow to report,
      // or runs inside a preview iframe with quirky viewport rules),
      // force it visible after 1.2s no matter what.
      setTimeout(() => el.classList.add('visible'), 1200);
    });
  }
  // If IntersectionObserver isn't supported at all, elements simply
  // stay in their default visible CSS state — nothing to do here.

  // Quality Assurance certificate — staggered checkmarks + scan line
  const qaCert = document.getElementById('qaCert');
  const qaRows = qaCert.querySelectorAll('.qa-cert-row');
  const qaIo = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        qaRows.forEach((row, i) => {
          setTimeout(() => row.classList.add('visible'), i * 180);
        });
        setTimeout(() => qaCert.classList.add('scan'), qaRows.length * 180 + 300);
        qaIo.unobserve(entry.target);
      }
    });
  }, { threshold: 0.35 });
  qaIo.observe(qaCert);

  // EKG draw-on-scroll
  const ekgPath = document.getElementById('ekgPath');
  const ekgIo = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        ekgPath.classList.add('animate');
        ekgIo.unobserve(entry.target);
      }
    });
  }, { threshold: 0.4 });
  ekgIo.observe(ekgPath);

  // Particle field in hero
  const canvas = document.getElementById('particles');
  const ctx = canvas.getContext('2d');
  let particles = [];

  function resizeCanvas() {
    canvas.width = canvas.parentElement.offsetWidth;
    canvas.height = canvas.parentElement.offsetHeight;
  }
  resizeCanvas();
  window.addEventListener('resize', resizeCanvas);

  function initParticles() {
    particles = [];
    const count = Math.min(60, Math.floor(canvas.width / 22));
    for (let i = 0; i < count; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        r: Math.random() * 1.4 + 0.4,
        vy: Math.random() * 0.25 + 0.08,
        o: Math.random() * 0.5 + 0.15
      });
    }
  }
  initParticles();
  window.addEventListener('resize', initParticles);

  function animateParticles() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    particles.forEach(p => {
      p.y -= p.vy;
      if (p.y < -5) p.y = canvas.height + 5;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(255,107,53,${p.o})`;
      ctx.fill();
    });
    requestAnimationFrame(animateParticles);
  }
  animateParticles();

  // Respect reduced motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('*').forEach(el => { el.style.animationDuration = '0.01ms'; });
  }
})();

(function () {

  /* =====================================================
     THE HUMAN ENGINE — self-contained module, no shared
     globals with the rest of the page.
     ===================================================== */
  const CHANNELS = {
    creatine:  { region: "region-muscles", target: { x: 0.5,  y: 0.27 }, pathway: "ATP-PC",   targetLabel: "MUSCLE",  dose: "5 G" },
    protein:   { region: "region-core",    target: { x: 0.5,  y: 0.40 }, pathway: "MPS",      targetLabel: "TISSUE",  dose: "25-30 G" },
    preworkout:{ region: "region-brain",   target: { x: 0.5,  y: 0.10 }, pathway: "CNS",      targetLabel: "FOCUS",   dose: "1 SCOOP" },
    collagen:  { region: "region-joints",  target: { x: 0.37, y: 0.72 }, pathway: "TYPE I+III", targetLabel: "JOINTS", dose: "10 G" }
  };

  let activeChannel = "creatine";
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setRegion(channelKey) {
    document.querySelectorAll(".region").forEach(r => r.classList.remove("lit"));
    const region = document.getElementById(CHANNELS[channelKey].region);
    if (region) region.classList.add("lit");
  }

  function typeInto(el, text) {
    if (reduceMotion) { el.innerHTML = text + '<span class="cursor"></span>'; return; }
    el.innerHTML = '<span class="cursor"></span>';
    let i = 0;
    const iv = setInterval(() => {
      i++;
      el.innerHTML = text.slice(0, i) + '<span class="cursor"></span>';
      if (i >= text.length) clearInterval(iv);
    }, 42);
  }

  function setReadout(channelKey) {
    const c = CHANNELS[channelKey];
    typeInto(document.getElementById("roPathway"), c.pathway);
    document.getElementById("roTarget").textContent = c.targetLabel;
    document.getElementById("roDose").textContent = c.dose;
  }

  document.querySelectorAll(".channel").forEach(ch => {
    ch.addEventListener("click", () => {
      const key = ch.getAttribute("data-channel");
      if (key === activeChannel) return;
      activeChannel = key;
      document.querySelectorAll(".channel").forEach(c => c.classList.remove("active"));
      ch.classList.add("active");
      setRegion(key);
      setReadout(key);
    });
  });

  const engineCanvas = document.getElementById("flowCanvas");
  const engineCtx = engineCanvas.getContext("2d");
  let engineW, engineH;

  function engineResize() {
    const rect = engineCanvas.parentElement.getBoundingClientRect();
    engineW = engineCanvas.width = rect.width * devicePixelRatio;
    engineH = engineCanvas.height = rect.height * devicePixelRatio;
    engineCanvas.style.width = rect.width + "px";
    engineCanvas.style.height = rect.height + "px";
  }
  engineResize();
  window.addEventListener("resize", engineResize);

  const PARTICLE_COUNT = reduceMotion ? 0 : 46;
  const engineParticles = [];

  function spawnParticle(initial) {
    const side = Math.random() < 0.5 ? "left" : "right";
    const t = CHANNELS[activeChannel].target;
    return {
      x: side === "left" ? -10 * devicePixelRatio : engineW + 10 * devicePixelRatio,
      y: (0.15 + Math.random() * 0.7) * engineH,
      cx: (side === "left" ? 0.22 : 0.78) * engineW + (Math.random() - 0.5) * 0.15 * engineW,
      cy: Math.random() * engineH,
      tx: t.x * engineW + (Math.random() - 0.5) * 0.07 * engineW,
      ty: t.y * engineH + (Math.random() - 0.5) * 0.05 * engineH,
      progress: initial ? Math.random() : 0,
      speed: 0.0022 + Math.random() * 0.0028,
      size: (0.8 + Math.random() * 1.6) * devicePixelRatio,
      alpha: 0.25 + Math.random() * 0.55
    };
  }

  for (let i = 0; i < PARTICLE_COUNT; i++) engineParticles.push(spawnParticle(true));

  function bezier(p, a, c, b) {
    const inv = 1 - p;
    return inv * inv * a + 2 * inv * p * c + p * p * b;
  }

  function engineTick() {
    engineCtx.clearRect(0, 0, engineW, engineH);

    for (let i = 0; i < engineParticles.length; i++) {
      const pt = engineParticles[i];
      pt.progress += pt.speed;

      if (pt.progress >= 1) {
        engineParticles[i] = spawnParticle(false);
        continue;
      }

      const x = bezier(pt.progress, pt.x, pt.cx, pt.tx);
      const y = bezier(pt.progress, pt.y, pt.cy, pt.ty);

      let a = pt.alpha;
      if (pt.progress < 0.1) a *= pt.progress / 0.1;
      if (pt.progress > 0.85) a *= (1 - pt.progress) / 0.15;

      const trailX = bezier(Math.max(0, pt.progress - 0.03), pt.x, pt.cx, pt.tx);
      const trailY = bezier(Math.max(0, pt.progress - 0.03), pt.y, pt.cy, pt.ty);
      const grad = engineCtx.createLinearGradient(trailX, trailY, x, y);
      grad.addColorStop(0, "rgba(255,107,53,0)");
      grad.addColorStop(1, `rgba(255,138,92,${a})`);
      engineCtx.strokeStyle = grad;
      engineCtx.lineWidth = pt.size;
      engineCtx.lineCap = "round";
      engineCtx.beginPath();
      engineCtx.moveTo(trailX, trailY);
      engineCtx.lineTo(x, y);
      engineCtx.stroke();
    }

    requestAnimationFrame(engineTick);
  }

  if (!reduceMotion) engineTick();
  setRegion(activeChannel);

})();